{
  "characters": {
    "万": [
      "萬"
    ],
    "与": [
      "與"
    ],
    "业": [
      "業"
    ],
    "东": [
      "東"
    ],
    "丝": [
      "絲"
    ],
    "两": [
      "兩"
    ],
    "丽": [
      "麗"
    ],
    "个": [
      "個"
    ],
    "义": [
      "義"
    ],
    "为": [
      "為"
    ],
    "么": [
      "麼"
    ],
    "习": [
      "習"
    ],
    "买": [
      "買"
    ],
    "于": [
      "於"
    ],
    "亿": [
      "億"
    ],
    "从": [
      "從"
    ],
    "们": [
      "們"
    ],
    "优": [
      "優"
    ],
    "会": [
      "會"
    ],
    "传": [
      "傳"
    ],
    "儿": [
      "兒"
    ],
    "关": [
      "關"
    ],
    "写": [
      "寫"
    ],
    "划": [
      "劃"
    ],
    "创": [
      "創"
    ],
    "别": [
      "別"
    ],
    "剧": [
      "劇"
    ],
    "劳": [
      "勞"
    ],
    "卖": [
      "賣"
    ],
    "双": [
      "雙"
    ],
    "发": [
      "發"
    ],
    "台": [
      "臺",
      "台"
    ],
    "后": [
      "後"
    ],
    "吗": [
      "嗎"
    ],
    "听": [
      "聽"
    ],
    "国": [
      "國"
    ],
    "声": [
      "聲"
    ],
    "学": [
      "學"
    ],
    "实": [
      "實"
    ],
    "对": [
      "對"
    ],
    "导": [
      "導"
    ],
    "将": [
      "將"
    ],
    "带": [
      "帶"
    ],
    "帮": [
      "幫"
    ],
    "干": [
      "幹"
    ],
    "应": [
      "應"
    ],
    "开": [
      "開"
    ],
    "张": [
      "張"
    ],
    "忆": [
      "憶"
    ],
    "恶": [
      "惡"
    ],
    "战": [
      "戰"
    ],
    "无": [
      "無"
    ],
    "时": [
      "時"
    ],
    "杂": [
      "雜"
    ],
    "来": [
      "來"
    ],
    "极": [
      "極"
    ],
    "构": [
      "構"
    ],
    "树": [
      "樹"
    ],
    "梦": [
      "夢"
    ],
    "欢": [
      "歡"
    ],
    "汉": [
      "漢"
    ],
    "没": [
      "沒"
    ],
    "涛": [
      "濤"
    ],
    "游": [
      "遊"
    ],
    "溃": [
      "潰"
    ],
    "点": [
      "點"
    ],
    "烦": [
      "煩"
    ],
    "爱": [
      "愛"
    ],
    "现": [
      "現"
    ],
    "电": [
      "電"
    ],
    "盗": [
      "盜"
    ],
    "着": [
      "著",
      "着"
    ],
    "视": [
      "視"
    ],
    "离": [
      "離"
    ],
    "窦": [
      "竇"
    ],
    "类": [
      "類"
    ],
    "线": [
      "線"
    ],
    "终": [
      "終"
    ],
    "经": [
      "經"
    ],
    "结": [
      "結"
    ],
    "给": [
      "給"
    ],
    "统": [
      "統"
    ],
    "绿": [
      "綠"
    ],
    "网": [
      "網"
    ],
    "胜": [
      "勝"
    ],
    "脚": [
      "腳"
    ],
    "蓝": [
      "藍"
    ],
    "见": [
      "見"
    ],
    "观": [
      "觀"
    ],
    "记": [
      "記"
    ],
    "讲": [
      "講"
    ],
    "设": [
      "設"
    ],
    "词": [
      "詞"
    ],
    "话": [
      "話"
    ],
    "该": [
      "該"
    ],
    "语": [
      "語"
    ],
    "说": [
      "說",
      "説"
    ],
    "请": [
      "請"
    ],
    "谁": [
      "誰"
    ],
    "贵": [
      "貴"
    ],
    "车": [
      "車"
    ],
    "过": [
      "過"
    ],
    "还": [
      "還"
    ],
    "这": [
      "這"
    ],
    "进": [
      "進"
    ],
    "递": [
      "遞"
    ],
    "锵": [
      "鏘"
    ],
    "长": [
      "長"
    ],
    "问": [
      "問"
    ],
    "间": [
      "間"
    ],
    "闻": [
      "聞"
    ],
    "难": [
      "難"
    ],
    "静": [
      "靜"
    ],
    "频": [
      "頻"
    ],
    "饭": [
      "飯"
    ],
    "驾": [
      "駕"
    ],
    "鲁": [
      "魯"
    ],
    "鹅": [
      "鵝"
    ]
  },
  "words": {
    "划算": [
      "划算"
    ],
    "发布": [
      "發佈"
    ],
    "台北": [
      "台北"
    ],
    "家里": [
      "家裡",
      "家裏"
    ],
    "杂志": [
      "雜誌"
    ],
    "没关系": [
      "沒關係"
    ],
    "面包": [
      "麵包",
      "麪包"
    ]
  },
  "readings": {
    "和": "<span class=\"py-syllable py-tone-4\" lang=\"zh-Latn-TW-pinyin\">hàn</span>",
    "谁": "<span class=\"py-syllable py-tone-2\" lang=\"zh-Latn-TW-pinyin\">shuí</span>"
  }
}
